module.exports = __webpack_public_path__ + "static/media/make-private.691f839a.svg";